import { FORM_LABEL } from '/source/_patterns/01-components/form/form';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as productService from '/source/js/services/productService';
import reviewsModule from './partials/reviews.hbs';
import reviewsModuleHeader from './partials/reviews-header.hbs';
import * as screenUtil from '/source/js/utils/screenUtil';
let page = 1;
let initialScroll = true;
let totalPages;

let $reviewsHeaderContainer;
let $reviewsContainer;
let $reviewsData;
let $annexReviewHeader = $('.annex-product-reviews');
let $addReviewElement;
let $showNewRatingReview;
const REVIEW_SECTION_CONTAINER = '#ProductDetailsContainer';
const REVIEW_SECTION = '#ReviewsSection';
let $loadMoreButton = $('#loadMoreReviews');
let $submitReviewButton = $('#submitReviewbtn');
const IS_ACTIVE = 'is--active';
let ratingCount = 0;
let isAuthenticatedUser;

let validation = {
    errorPlacement: function errorPlacement(error, element) {
        if(element.attr('name') === 'reviewCount') {
            error.appendTo('.add-review__error');
        } else {
            error.insertAfter(element);
        }
    },
    onfocusout: function (element) {
        this.element(element);
    },
    highlight: function (element) {
        $(element).parent().addClass('is--error');
    },
    unhighlight: function (element) {
        $(element).parent().removeClass('is--error');
    },
    errorElement: 'span',
    rules: {
        firstName: {
            required: true
        },
        reviewCount: {
            required: true
        }
    }
};

async function loadMore() {
    var reviewsSystemProductId = $('#hidden-review-product').val();
    let $productRatingReviewsHeader = $('.product-reviews__ratings-header');

    if($showNewRatingReview !== 'true') {
        $loadMoreButton.prop('disabled', true);
        if(!reviewsSystemProductId) {
            $loadMoreButton.remove();
            return;
        }

        try {
            let result = await productService.getProductReviews({
                page: page,
                productReviewsSystemId: reviewsSystemProductId
            });

            if(result) {
                if(page === 1 && (result.ProductRating == null || result.ProductRating.Rating_Count <= 0 ||
                    result.ProductRating.Rating_Count == null)) {
                    if(!isAuthenticatedUser) {
                        return;
                    } else {
                        $reviewsData.show();
                        $addReviewElement.show();
                        $productRatingReviewsHeader.hide();
                        return;
                    }
                }
                loadReviews(result, page === 1);
                $reviewsData.show();
                $addReviewElement.show();
                $loadMoreButton.prop('disabled', false);
                if(page === parseInt(totalPages)) {
                    $loadMoreButton.remove();
                } else {
                    page++;
                }
            }
        } catch (ex) {
            console.error(ex);
        }
    } else {
        $loadMoreButton.remove();
    }
}

async function submitReview() {
    let $addReview = $('.add-review__form');
    if(!$addReview.valid()) {
        return;
    }
    $submitReviewButton.prop('disabled', true);
    var reviewsSystemProductId = $('#hidden-review-product').val();
    var review = $('#yourReview').val();
    var firstName = $('#firstName').val();
    var lastInitial = $('#lastInitial').val();
    if(!reviewsSystemProductId) {
        return;
    }
    try {
        loadSpinner();
        let result = await productService.saveProductReview({
            ProductId: parseInt(reviewsSystemProductId),
            Reviewer: firstName + ' ' + lastInitial,
            Rating: parseInt(ratingCount),
            Review: review
        });

        if(result) {
            ResetSubmitForm();
            stopSpinner();
            $submitReviewButton.prop('disabled', false);
            $('.add-review__success').removeClass('d-none');
            $('.add-review__failed').addClass('d-none');
        } else {
            stopSpinner();
            $submitReviewButton.prop('disabled', false);
            $('.add-review__failed').removeClass('d-none');
            $('.add-review__success').addClass('d-none');
        }
    } catch (ex) {
        stopSpinner();
        console.error(ex);
    }
}

function triggerInputEvent() {
    let $input = $('.reviews-form');
    $input.each(function (idx, e) {
        let $element = $(e);
        if (!!$element.val()) {//eslint-disable-line
            formInput.call(e);
        }
    });
}

function ResetSubmitForm() {
    // only reset Review and Ratings. Keep values for FirstName and lastInitial
    let $addReviewCheckbox = $('.add-review__checkbox');
    if($addReviewCheckbox.prop('checked') === true) {
        $addReviewCheckbox.prop('checked', false);
        $addReviewCheckbox.parents('label').removeClass('is--full');
    }
}

function loadReviews(reviews, loadHeader) {
    if(!reviews) return;

    $loadMoreButton.show();

    if(loadHeader) {
        let reviewsHeaderHtml = reviewsModuleHeader(reviews);
        $reviewsHeaderContainer.append(reviewsHeaderHtml);
        totalPages = reviews.ProductRating.Total_Pages;
    }
    let reviewsHtml = reviewsModule(reviews);

    $reviewsContainer.append(reviewsHtml);
}

function validateReview() {
    let $addReview = $('.add-review__form');
    $addReview.validate(validation);
}

function reviewsContainerScrolling() {
    window.addEventListener('scroll', function () {
        if(screenUtil.isPartialElementInViewPort(REVIEW_SECTION, REVIEW_SECTION_CONTAINER)) {
            if(initialScroll) {
                initialScroll = false;
                loadMore();
            }
        }
    });
}

function checkStars() {
    let $this = $(this);
    if($this.prop('checked') === true) {
        $this.parents('label').prevAll().addClass('is--full');
        ratingCount = $this.parents('label').prevAll().length + 1;
        $this.parents('label').nextAll().removeClass('is--full');
    }
}

function showReview() {
    $('.add-review').removeClass('d-none');
    $('html,body').animate({
        scrollTop: $('.add-review').offset().top - 100
    });
    // let validator = $('.add-review__form').validate();
    // validator.resetForm();
    $('.add-review__form').find('textarea').val('');
    $('.form-label').removeClass('is--active');
    triggerInputEvent();
    $('.add-review__checkbox').prop('checked', false);
    $('.form-label--checkbox').removeClass('is--full');
    $('.add-review__success').addClass('d-none');
    $('.add-review__failed ').addClass('d-none');
}

function formInput() {
    let $this = $(this);
    $this.addClass(IS_ACTIVE);
    $this.siblings(FORM_LABEL).addClass(IS_ACTIVE);
    if(!$this.val()) {
        $this.removeClass(IS_ACTIVE);
        $this.siblings(FORM_LABEL).removeClass(IS_ACTIVE);
    }
}

function initEventHandlers() {
    let $addReviewCheckbox = $('.add-review__checkbox');
    let $writeReview = $('.product-reviews__write-review');
    let $formInput = $('.form-input');
    reviewsContainerScrolling();
    $loadMoreButton.on('click', loadMore);
    $submitReviewButton.on('click', submitReview);
    $addReviewCheckbox.on('change', checkStars);
    $writeReview.on('click', showReview);
    $formInput.on('input', formInput);
    validateReview();
    triggerInputEvent();
    $('.add-review__form').submit(function (e) {
        // Stop the form submitting
        e.preventDefault();
    });
}

$(function () {
    $reviewsData = $('.product-reviews');
    $addReviewElement = $('.add-review');
    $showNewRatingReview = $('#hidden-show-new-rating-review').val();

    if(!$reviewsData.length && $showNewRatingReview !== 'true') return;

    if($showNewRatingReview !== 'true') $annexReviewHeader.hide();

    initEventHandlers();

    $reviewsHeaderContainer = $('.product-reviews__ratings-header');
    $reviewsContainer = $('.product-reviews__tab');
    let productData = $('.product').data('product-details');
    isAuthenticatedUser = productData.IsAuthenticatedUser;
    let reviews = $reviewsData.data('product-details');

    if(reviews) {
        loadReviews(reviews, true);
    }
});
